export default __webpack_public_path__ + "static/media/bill2.56236784.png";